import { ApiCore } from '@/services/api/utils/core.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'

const url = 'login'
const plural = 'logins'
const single = 'login'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: true,
	update: false,
	remove: false,
	url: url,
	plural: plural,
	single: single
})

api.massUpdate = () => {
	// Custom API Logic
}

api.siteVerify = (params) => {
	return axios
		.post(`${apiProvider.BASE_URL}/login/site-verify`, params)
		.then(handleResponse)
		.catch(handleError);
}


export default api
